import { Injectable, signal, Injector } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { BehaviorSubject } from 'rxjs'
import { TokenSave } from '../interfaces'

const ACCESS_TOKEN_STORAGE_KEY = 'invalid_access_token'
const REFRESH_TOKEN_STORAGE_KEY = 'invalid_refresh_token'
const FIREBASE_TOKEN_STORAGE_KEY = 'invalid_firebase_token'

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private readonly $isRefreshing = new BehaviorSubject<boolean>(false)
  isRefreshing$ = this.$isRefreshing.asObservable()
  readonly $$isRefreshing = toSignal(this.$isRefreshing)

  private readonly $accessToken = new BehaviorSubject<string | null>(null)
  accessToken$ = this.$accessToken.asObservable()
  $$accessToken = toSignal(this.$accessToken)

  $$refreshToken = signal(null as string | null)
  $$firebaseToken = signal(null as string | null)
  $$userMail = signal(null as string | null)

  constructor(private injector: Injector) {
    this.$accessToken.next(localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY))
    this.$$refreshToken.set(localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY))
    this.$$firebaseToken.set(localStorage.getItem(FIREBASE_TOKEN_STORAGE_KEY))
  }

  setRefreshStatus(isRefreshing: boolean) {
    this.$isRefreshing.next(isRefreshing)
  }

  save({ accessToken, refreshToken }: TokenSave) {
    localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, accessToken)
    this.$accessToken.next(accessToken)

    localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken)
    this.$$refreshToken.set(refreshToken)
  }

  clear() {
    localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY)
    this.$accessToken.next(null)

    localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY)
    this.$$refreshToken.set(null)

    localStorage.removeItem(FIREBASE_TOKEN_STORAGE_KEY)
    this.$$firebaseToken.set(null)
  }

  saveFireToken(fireToken: string) {
    localStorage.setItem(FIREBASE_TOKEN_STORAGE_KEY, fireToken)
    this.$$firebaseToken.set(fireToken)
  }
}
